import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { hasModelConcepts } from 'src/utils/hasModelConcepts';

// also see hasModelConcepts util fn
export const hasModelConceptsSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(diagramSnapshotSelector(projectId), (diagramSnapshot) => {
      if (!diagramSnapshot?.model) {
        return false;
      }

      return hasModelConcepts(diagramSnapshot);
    })
);
